import axiosInstance from './axiosInstance';
import { API_CONFIG } from './config';
import { getRequesterId } from '../utils/storageManager';
import { GetWarehouseLocationsResponse } from './types';

export const warehouseService = {
    /**
     * Get all warehouse locations
     */
    getWarehouseLocations: async (): Promise<GetWarehouseLocationsResponse> => {
        try {
            const requesterId = getRequesterId();
            const response = await axiosInstance.get(
                API_CONFIG.ENDPOINTS.GET_WAREHOUSE_LOCATIONS,
                {
                    params: { requesterId },
                }
            );
            return {
                status: response.status,
                data: response.data?.data ?? response.data ?? {},
            };
        } catch (error: any) {
            return {
                status: error?.response?.status ?? 500,
                data: undefined,
            };
        }
    },
};
